<template>
  <section class="guidance-display-screen-log">
    <div class="searchbox">
      <form action="#" method="get" class="form-inline form-float">
        <div class="form-group others">
          <span class="go-back">
            <div  @click="goBack">
              <i class="el-icon-arrow-left"></i>返回
            </div>
          </span>
        </div>
        <!-- <div class="form-group">
          <label for>ID:</label>
          <input
            v-model.trim="search.ledInductId"
            class="form-control"
            type="text"
            placeholder
            size="12"
            disabled
          />
        </div> -->
      </form>
    </div>
    <div class="list-right">
      <el-table
        ref="table"
        border
        :data="tableListData"
        height="100%"
        :header-cell-style="tableHeaderStyle"
        :cell-style="styleObj"
        v-loading="tableLoading"
      >
        <el-table-column
          show-overflow-tooltip
          label="记录ID"
          prop="id"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="控制卡ID"
          prop="ledcardId"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="记录内容"
          prop="logType"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="记录时间"
          prop="crtTime"
        ></el-table-column>
      </el-table>
    </div>
    <Page
      v-on:pagination="receivePaginationData"
      v-bind:pageObj="pageObj"
    ></Page>
  </section>
</template>

<script>
import Page from "@/page/commons/page";

export default {
  data() {
    return {
      tableLoading: false,
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      search: {
        pageNumber: 1,
        pageSize: 10,
        ledInductId: this.$route.query.ledInductId || "",
      },
      tableListData: [],
      pageObj: {},
    };
  },
  components: {
    Page,
  },
  mounted() {
    if (!this.search.ledInductId) {
      // this.$message({
      //   type: "warning",
      //   message: "未传入控制卡ID，无法加载下发记录",
      // });
      return;
    }
    this.tableList(1);
  },
  methods: {
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.tableList(this.search.pageNumber);
    },
    tableList(curPage) {
      this.tableLoading = true;
      this.$get("/api/parking/ledInductLog/page", {
        limit: this.search.pageSize,
        page: curPage,
        ledInductId: this.search.ledInductId,
      })
        .then((res) => {
          this.tableListData = res?.data?.rows ?? [];
          const pageObj = {
            curIndex: res.data.offset,
            rowsCount: res.data.total,
          };
          this.pageObj = { ...pageObj };
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    goBack() {
      this.$router.push({
        path: "/main/equipment/guidance-display-screen",
      });
    },
  },
};
</script>

<style>
.guidance-display-screen-log .el-select {
  display: inline-block;
  vertical-align: middle;
}
.guidance-display-screen-log .go-back {
  cursor: pointer;
  color: #409eff;
}
</style>


